import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Constraint, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeConstraint(data: Boundaries["removeConstraint"]["request"]): void;
}

function useRemoveConstraint(constraint: Identifiable<Constraint>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveConstraintRequestPending(constraint),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveConstraintRequestSuccess(constraint),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveConstraintRequestFailure(constraint),
    ),
    removeConstraint: core.removeConstraint,
  };
}

export { useRemoveConstraint };
